<template>
    <section id="content" v-if="getFlagSharedShowFlightSearchResults">
        <div class="container">
            <div class="block" id="contentElement">
                <!-- >>> BreadCrumbs - Row -->
                <div class="row">
                    <sdr-breadcrumbs active_item="first" :module="modulo"></sdr-breadcrumbs>
                </div>
                <!-- <<< BreadCrumbs - Row -->


                <!-- >>> 'FlightSearchResults' - Row -->
                <div class="row">
                    <!-- >>> Left Side: 'SearchResults' -->
                    <div class="col-sm-8 col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title" style="margin-bottom:30px;" v-if="modulo === 'booking'"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectflightheadline[getCurrentLocale] }}</h1>
                            <h1 class="idea-title" style="margin-bottom:30px;" v-if="modulo === 'services'"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectflightservicesheadline[getCurrentLocale] }}</h1>
                        </div>



                        <!-- >>> SearchResults Tabs -->
                        <div class="tab-container style1">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs full-width" v-if="modulo === 'booking'">
                                <li v-bind:class="{ active: isActive === 'outwardsearchresults', 'icon-check2': getBookingFlightIdSelectedOutward !== null }">
                                    <a href="#outwardsearchresults" data-toggle="tab" @click.prevent="isActive ='outwardsearchresults'">{{ departureflightlist[getCurrentLocale] }}</a>
                                </li>
                                <li v-bind:class="{ active: isActive === 'returnsearchresults', 'icon-check2': getBookingFlightIdSelectedReturn !== null}" v-if="getBookingUsersSearchData.rTrip === true">
                                    <a href="#returnsearchresults" data-toggle="tab" @click.prevent="isActive ='returnsearchresults'" v-bind:class="{ 'buttonglowing': getBookingFlightIdSelectedReturn === null && getBookingFlightIdSelectedOutward !== null }">{{ returnflightlist[getCurrentLocale] }}</a>
                                </li>
                            </ul>
                            <ul class="tabs full-width srvcs" v-if="modulo === 'services'">
                                <li v-bind:class="{ active_srvcs: isActive === 'outwardsearchresults', 'icon-check3': getBookingFlightIdSelectedOutward !== null }">
                                    <a href="#outwardsearchresults" data-toggle="tab" @click.prevent="isActive ='outwardsearchresults'">{{ departureflightlist[getCurrentLocale] }}</a>
                                </li>
                                <li v-bind:class="{ active_srvcs: isActive === 'returnsearchresults', 'icon-check3': getBookingFlightIdSelectedReturn !== null }" v-if="getBookingUsersSearchData.rTrip === true">
                                    <a href="#returnsearchresults" data-toggle="tab" @click.prevent="isActive ='returnsearchresults'" v-bind:class="{ 'buttonglowing': getBookingFlightIdSelectedReturn === null && getBookingFlightIdSelectedOutward !== null }">{{ returnflightlist[getCurrentLocale] }}</a>
                                </li>
                            </ul>
                            <!-- <<< TabHeader:  -->


                            <!-- >>> TabContent: Out/Ret Results -->
                            <div class="tab-content">
                                <!-- >>> Tab: 'outwardsearchresults' -->
                                <div id="outwardsearchresults" class="tab-pane fade in active">
                                    <div class="pricing-table">
                                        <div class="header clearfix" style="border-bottom: 0px;">
                                            <i class="soap-icon-plane-right circle takeoff-effect yellow-color"></i>
                                            <h3 style="padding-top: 5px;" v-if="filterOutwardOnly(getBookingFlightSearchResults).length !== 0">{{ getBookingDepArprtName + ' - ' + getBookingDesArprtName }}</h3>
                                            <h3 style="padding-top: 5px;" v-if="filterOutwardOnly(getBookingFlightSearchResults).length === 0">{{ getBookingDepArprtName + ' - ' + getBookingDesArprtName }} - {{ noresultsout[getCurrentLocale] }}</h3>
                                        </div>
                                    </div>

                                    <!-- >>> Outward Search Results Loop -->
                                    <div class="row image-box" v-for="(flight) in filterOutwardOnly(getBookingFlightSearchResults)" v-bind:key="flight.id">
                                        <div class="col-sm-12 col-md-12">
                                            <div class="flight-list listing-style3 flight">
                                                <article class="box div_hover">
                                                    <!-- >>> The Logo -->
                                                    <figure class="col-xs-3 col-sm-2">
                                                        <span v-if="modulo === 'booking' && (flight.prcs[0] !== undefined && flight.warn === '')"><img alt src="/res/images/logo-centered3.png"></span>
                                                        <span v-if="modulo === 'booking' && (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')"><img alt src="/res/images/logo-centered3-bw.png"></span>
                                                        <span v-if="modulo === 'services'"><img alt src="/res/images/logo-centered3.png"></span>
                                                        <span v-if="modulo === 'booking'"  v-show="getBookingFlightIdSelectedOutward === flight.id" class="discount"><span class="discount-text">{{ soldout[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                                        <span v-if="modulo === 'services'" v-show="getBookingFlightIdSelectedOutward === flight.id" class="discount" ><span class="discount-text">{{ soldoutsrvcs[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                                    </figure>
                                                    <!-- >>> The Logo -->

                                                    <!-- >>> The Flight -->
                                                    <sdr-shared-fsr-flight :flight="flight" flightdirection="outward" :modulo="modulo"></sdr-shared-fsr-flight>
                                                    <!-- <<< The Flight -->
                                                </article>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <<< Outward Search Results Loop -->
                                </div>
                                <!-- <<< Tab: 'outwardsearchresults' -->


                                <!-- >>> Tab: 'returnsearchresults' -->
                                <div id="returnsearchresults" class="tab-pane fade">
                                    <div class="pricing-table">
                                        <div class="header clearfix" style="border-bottom: 0px;">
                                            <i class="soap-icon-plane-right takeoff-effect1 circle yellow-color"></i>
                                            <h3 style="padding-top: 5px;" v-if="filterReturnOnly(getBookingFlightSearchResults).length !== 0">{{ getBookingDesArprtName + ' - ' + getBookingDepArprtName }}</h3>
                                            <h3 style="padding-top: 5px;" v-if="filterReturnOnly(getBookingFlightSearchResults).length === 0">{{ getBookingDesArprtName + ' - ' + getBookingDepArprtName }} - {{ noresultsret[getCurrentLocale] }}</h3>
                                        </div>
                                    </div>

                                    <!-- >>> Return Search Results Loop -->
                                    <div class="row image-box" v-for="(flight) in filterReturnOnly(getBookingFlightSearchResults)" v-bind:key="flight.id">
                                        <div class="col-sm-12 col-md-12">
                                            <div class="flight-list listing-style3 flight">
                                                <article class="box div_hover">
                                                    <!-- >>> The Logo -->
                                                    <figure class="col-xs-3 col-sm-2">
                                                        <span v-if="modulo === 'booking' && (flight.prcs[0] !== undefined && flight.warn === '')"><img alt src="/res/images/logo-centered3.png"></span>
                                                        <span v-if="modulo === 'booking' && (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')"><img alt src="/res/images/logo-centered3-bw.png"></span>
                                                        <span v-if=" modulo === 'services'"><img alt src="/res/images/logo-centered3.png"></span>
                                                        <span v-if=" modulo === 'booking'"  v-show="getBookingFlightIdSelectedReturn === flight.id" class="discount"><span class="discount-text">{{ soldout[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                                        <span v-if=" modulo === 'services'" v-show="getBookingFlightIdSelectedReturn === flight.id" class="discount"><span class="discount-text">{{ soldoutsrvcs[getCurrentLocale] }}</span></span> <!-- >>> 'Added' Ribbon -->
                                                    </figure>
                                                    <!-- >>> The Logo -->

                                                    <!-- >>> The Flight -->
                                                    <sdr-shared-fsr-flight :flight="flight" flightdirection="return" :modulo="modulo"></sdr-shared-fsr-flight>
                                                    <!-- <<< The Flight -->
                                                </article>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <<< Return Search Results Loop -->
                                </div>
                                <!-- <<< Tab: 'returnsearchresults' -->
                            </div>
                            <!-- <<< TabContent: Out/Ret Results -->
                        </div>
                        <!-- <<< SearchResults Tabs -->



                        <!-- >>> ProceedButton(s) -->
                        <!-- >>> Variante 1: Normal, RoundTrip, Flights in both Directions -->
                        <br />
                        <div v-if="getBookingUsersSearchData.rTrip === true && (filterOutwardOnly(getBookingFlightSearchResults).length !== 0 && filterReturnOnly(getBookingFlightSearchResults).length !== 0)">
                            <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }" v-if="getFlagBookingOutwardFlightSelected === true && getFlagBookingReturnFlightSelected === true" @click.prevent="call_nextCallBookingOrServices(modulo)">{{ proceed[getCurrentLocale] }}</button>
                            <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingOutwardFlightSelected !== true || getFlagBookingReturnFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                        </div>

                        <!-- >>> Variante 2: Normal, RoundTrip, No Flights on Outward OR Return -->
                        <div v-if="getBookingUsersSearchData.rTrip === true && (filterOutwardOnly(getBookingFlightSearchResults).length === 0 || filterReturnOnly(getBookingFlightSearchResults).length === 0)">
                            <!-- <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }" v-if="getFlagBookingOutwardFlightSelected === true" @click.prevent="call_nextCallBookingOrServices(modulo)">{{ proceed[getCurrentLocale] }}</button> -->
                            <!-- <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingOutwardFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a> -->
                            <a class="button btn-large uppercase full-width silver">{{ proceed[getCurrentLocale] }} </a>

                        </div>

                        <!-- >>> Variante 3: Outward Only -->
                        <div v-if="getBookingUsersSearchData.rTrip !== true">
                            <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }" v-if="getFlagBookingOutwardFlightSelected === true" @click.prevent="call_nextCallBookingOrServices(modulo)">{{ proceed[getCurrentLocale] }}</button>
                            <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingOutwardFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                        </div>
                        <!-- <<< ProceedButton(s) -->
                    </div>
                    <!-- <<< Left Side: 'SearchResults' -->



                    <!-- >>> Right Side: Sidebar -->
                    <div class="sidebar col-sms-6 col-sm-4 col-md-3 topDistance" style="">
                        <h2>&nbsp;</h2>
                        <h4 class="search-results-title" style="color: #4f657e !important;"><i class="soap-icon-search"></i><b>{{ getBookingFlightSearchResults.length }}</b> {{ resultsshown[getCurrentLocale] }}.</h4>

                        <!-- >>> VueCmp - 'sdr-modifysearch-box', 'Modify Search' -->
                        <sdr-modifysearch-box v-if="modulo === 'booking'"></sdr-modifysearch-box>
                        <!-- <<< VueCmp - 'sdr-modifysearch-box', 'Modify Search' -->

                        <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                        <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                        <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    </div>
                    <!-- <<< Right Side: Sidebar -->
                </div>
                <!-- <<< 'FlightSearchResults' - Row -->
            </div>
        </div>










        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="booking-error-modal-sameday"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="100"
                :min-height="100"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="500px"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="booking-error-modal-sameday-content" style="border: 2px solid red;">
                    <section id="content" style="padding:20px; min-height: 100px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:10px;"><span class="index"><i class="soap-icon-notice circle"></i></span>{{ modal_headline_rebooking_error[getCurrentLocale] }}</h3>
                                </div>

                                <div>
                                    <br />
                                    <h4 v-html="modal_content_rebooking_error[getCurrentLocale]"></h4>
                                </div>
                            </div>
                        </div>
                    </section>
                    <button type="button" class="btn-large full-width totalbutton sundair" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 0px;" @click.prevent="onClick_CloseModal(modulo)"> {{ closemodal[getCurrentLocale] }}</button>
                </div>
        </modal>
    </section>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import Flight from './components/fsr/Flight.vue';
    import ModifySearchBox from '../../booking/flightsearch/ModifySearchBox.vue';
    import SharedCart from '../../shared/cart/Cart.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-shared-fsr-flight': Flight, // fsr=>flight search results
            'sdr-modifysearch-box': ModifySearchBox,
            'sdr-shared-cart': SharedCart,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> ---------------------------------------------------------
                isActive: 'outwardsearchresults',
                // >>> ---------------------------------------------------------
                callCounter: 0,
                // >>> ---------------------------------------------------------
                pleaseselectflightheadline: {
                    en: 'Step 1: Please select your Flight(s).',
                    de: 'Schritt 1: Bitte wählen Sie Ihre Flug/Flüge aus.'
                },
                pleaseselectflightservicesheadline: {
                    en: 'Step 1: Please select your already booked flight(s).',
                    de: 'Schritt 1: Bitte wählen Sie Ihre bereits gebuchten Flug/Flüge aus.'
                },
                out: {
                    en: 'SOLD OUT',
                    de: 'AUSV.'
                },
                outwardflight: {
                    en: 'Outward Flight',
                    de: 'Hinflug',
                },
                returnflight: {
                    en: 'Return Flight',
                    de: 'Rückflug',
                },
                departureflightlist: {
                    en: 'Departure Flight List',
                    de: 'Hinflüge',
                },
                returnflightlist: {
                    en: 'Return Flight List',
                    de: 'Rückflüge',
                },
                totaltime: {
                    en: 'total time',
                    de: 'Dauer',
                },
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                to: {
                    en: 'to',
                    de: 'nach',
                },
                hourstxt: {
                    en: 'HOURS',
                    de: 'STUNDEN',
                },
                minutestxt: {
                    en: 'MINUTES',
                    de: 'MINUTEN',
                },
                selectflight: {
                    en: 'SELECT FLIGHT',
                    de: 'FLUG WÄHLEN',
                },
                selectbookedflight: {
                    en: 'YES, MY FLIGHT',
                    de: 'JA, MEIN FLUG',
                },
                taxesandfees: {
                    en: 'Taxes and Fees',
                    de: 'Steuern und Gebühren'
                },
                airfare: {
                    en: 'Airfare',
                    de: 'Flugpreis'
                },
                airporttaxes: {
                    en: 'Airport taxes',
                    de: 'Flughafengebühren'
                },
                aviationtax: {
                    en: 'Aviation tax',
                    de: 'Luftverkehrssteuer'
                },
                kerosenesurcharge: {
                    en: 'Kerosene surcharge',
                    de: 'Kerosinzuschlag'
                },
                securitycharges: {
                    en: 'Security charges',
                    de: 'Sicherheitsgebühren'
                },
                servicecharges: {
                    en: 'Service charges',
                    de: 'Servicegebühren'
                },
                resultsshown: {
                    en: 'flights (out/ret) found',
                    de: 'Flüge (Hin/Rück)'
                },
                avgpers: {
                    en: 'AVG/PERSON',
                    de: 'PRO PERSON'
                },
                departuredate: {
                    en: 'Date Departure',
                    de: 'Abflugdatum',
                },
                returndate: {
                    en: 'Date Return',
                    de: 'Rückflugdatum',
                },
                proceed: {
                    en: 'PROCEED TO PASSENGER DATA',
                    de: 'WEITER ZU PASSAGIERDATEN',
                },
                modifysearch: {
                    en: 'Modify Search',
                    de: 'Suche verändern',
                },
                seetaxes: {
                    en: 'See Taxes & Fees',
                    de: 'Steuern & Gebühren ansehen',
                },
                isthisyourflight: {
                    en: 'Your Flight?',
                    de: 'Ihr Flug?',
                },
                thisismyflight: {
                    en: 'Yes, my Flight',
                    de: 'Ja, mein Flug',
                },
                thisis: {
                    en: 'Is this',
                    de: 'Ist das',
                },
                noresultsout: {
                    en: 'Attention: No more outward flights found!',
                    de: 'Achtung: Keine Hinflüge mehr gefunden!',
                },
                noresultsret: {
                    en: 'Attention: No more return flights found!',
                    de: 'Achtung: Keine Rückflüge mehr gefunden!',
                },
                soldout: {
                    en: 'Selected!',
                    de: 'Gewählt!',
                },
                soldoutsrvcs: {
                    en: 'Your Flight!',
                    de: 'Ihr Flug!',
                },

                errornoseatsrvcsonoutward : {
                    en: 'Attention: No more seats on your outbound flight!',
                    de: 'Achtung: Keine Sitze mehr auf Ihren Hinflug!',
                },
                errornoseatsrvcsonreturn : {
                    en: 'Attention: No more seats on your return flight!',
                    de: 'Achtung: Keine Sitze mehr auf Ihren Rückflug!',
                },
                // >>> ---------------------------------------------------------
                amenities_services: {
                    en: 'Additional services can be reserved on this flight: Seats' ,
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze',
                },
                amenities_meal: {
                    en: 'Additional services can be reserved on this flight.: Meals',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen',
                },
                amenities_lugagge: {
                    en: 'Additional services can be reserved on this flight.: Additional Luggage',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck',
                },
                // >>> ---------------------------------------------------------
                modal_headline_rebooking_error: {
                    en: 'Attention: Flights same day',
                    de: 'Achtung: Flüge am gleichen Tag',
                },
                modal_content_rebooking_error: {
                    en: 'Dear customer, you have selected outbound and return flights on the same day. Are you sure?',
                    de: 'Lieber Kunde, sie haben Hin- und Rückflug am selben Tag ausgewählt. Sind Sie sich sicher?',
                },
                closemodal: {
                    en: 'Close',
                    de: 'Schliessen',
                },
                // >>> ---------------------------------------------------------
                // currentLocale: 'de',
                gotSeatOnOut:  false, // Flag
                gotSeatOnRet: false, // Flag
                bookableServicesCallOutDidRun: false, // Flag
                bookableServicesCallRetDidRun: false, // Flag
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedShowFlightSearchResults',
                'getBookingFlightSearchResults',
                'getBookingDepArprtCode', // Users Search Data, Part 1
                'getBookingDesArprtCode',
                'getBookingDepArprtName',
                'getBookingDesArprtName',
                'getBookingUsersSearchData', // Users Search Data, Part 2
                'getFlagBookingOutwardFlightSelected', // CONTROL FLAG
                'getFlagBookingReturnFlightSelected', // CONTROL FLAG
                'getBookingFlightIdSelectedOutward', // get: selected Flight id out
                'getBookingFlightIdSelectedReturn', // get: selected Flight id ret
                'getBookingPriceIdSelectedOutward', // get: selected Price id out
                'getBookingPriceIdSelectedReturn', // get: selected Price id ret
                'getBookingSrvcsSeatExistOnOut',
                'getBookingSrvcsSeatExistOnRet',

                'getBookingCart',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytopushpassengersnotbookingno' ('All Calls done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> created');
            eventBus.$on('readytopushpassengersnotbookingno', this.onEmit_ReadyToPushPassengers);
            eventBus.$on('needtorerender', this.onEmit_NeedToRerender);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> created');
            eventBus.$off('readytopushpassengersnotbookingno', this.onEmit_ReadyToPushPassengers);
            eventBus.$off('needtorerender', this.onEmit_NeedToRerender);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingUpdateCart',
                'actn_setBookingLockfaresResults', // set: 'Lockfares Results'
                'actn_bookingSeatReservationLockingCodeResults', // set: 'Lockingcodes Results'
                'actn_bookingSeatplanResults', // set: 'Seatplan Results'
                'actn_setBookingSrvcsSeatExistOnOut', // set: 'Srvcs SEAT exist on OUT'
                'actn_setBookingSrvcsSeatExistOnRet', // set: 'Srvcs SEAT exist on RET'
                'actn_setServicesBookableServicesResults', // set: 'Bookable Services Results' (srvcs)
                'actn_call_registrationBookingoptions', // Call: get 'bookingoptions'
                'actn_call_bookableServices',  // Call: get 'bookable services'
                'actn_Flag_bookableServicesCallRetDidRun',
                'actn_call_getSeatReservationLockingCode', // call:
            ]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * call_nextCallBookingOrServices()
            *
            * Desc: Decides which Calls are next?! 'Booking' or 'Services'.
            * Note: PreCheck, 'Same day?' #804
            *
            * @param {String} modulo ('booking', 'services')
            */
            call_nextCallBookingOrServices: function (modulo) {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_nextCallBookingOrServices');
                // >>> precheck -----------------------------------
                if (this.getBookingUsersSearchData.rTrip === true && (this.getBookingCart[0].outward.depDT.substr(0, 10) === this.getBookingCart[0].return.depDT.substr(0, 10))) {

                    me.$modal.show('booking-error-modal-sameday');

                } else {

                    if (modulo === 'booking') {
                        this.call_showFares(); // 1st Call in a Row ..
                    }

                    if (modulo === 'services') {
                        this.call_registrationBookingoptions();                     // Call 1: 'get bookingoptions'
                        this.call_bookableServices('outward');                      // Call 2: 'get bookableservices' - outward

                        if (this.getBookingFlightIdSelectedReturn !== null) {
                            this.call_bookableServices('return');                   // Call 2: 'get bookableservices' - return
                        } else {
                            // this.bookableServicesCallRetDidRun = true; // no RET Flight, we pretend call for RET  did run
                            this.actn_Flag_bookableServicesCallRetDidRun(true);         // we fake it
                        }
                    }

                }

            }, // eof call_nextCallBookingOrServices()


            /*******************************************************************
            * onClick_CloseModal()
            *
            * Desc: Decides which Calls are next?! 'Booking' or 'Services'.
            * Note: Close and Go on ...
            *
            */
            onClick_CloseModal: function(modulo) {

                var me = this;


                me.$modal.hide('booking-error-modal-sameday');
                if (modulo === 'booking') {
                    this.call_showFares(); // 1st Call in a Row ..
                }

                if (modulo === 'services') {
                    this.call_registrationBookingoptions();                     // Call 1: 'get bookingoptions'
                    this.call_bookableServices('outward');                      // Call 2: 'get bookableservices' - outward

                    if (this.getBookingFlightIdSelectedReturn !== null) {
                        this.call_bookableServices('return');                   // Call 2: 'get bookableservices' - return
                    } else {
                        // this.bookableServicesCallRetDidRun = true; // no RET Flight, we pretend call for RET  did run
                        this.actn_Flag_bookableServicesCallRetDidRun(true);         // we fake it
                    }
                }

            }, // eo function onClick_CloseModal()



            /******************************************************************* 'ServiceCalls - Booking'
            * ServiceCalls: 'Booking'
            *******************************************************************/
            /*******************************************************************
            * Call::'/booking/showfares'
            *
            * Desc:
            * Note: I only take 'fareskeycode' for Call 'lockFares' here.
            * Note: Call: Module::'Booking'.
            *
            */
            call_showFares: function () {

                var me = this,
                    hdrs = '';


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_showFares');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    idOutwardprice: this.getBookingPriceIdSelectedOutward,
                    idReturnprice: this.getBookingUsersSearchData.rTrip === true ? this.getBookingPriceIdSelectedReturn : null,
                    noAdultPax: this.getBookingUsersSearchData.noADT,
                    noChildPax: this.getBookingUsersSearchData.noCHD,
                    noInfants: this.getBookingUsersSearchData.noINF
                };


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/booking/showfares/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.call_lockFares(response.data.faresKey); // Call 'lockfares' immediately thereafter
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_showFares()


            /*******************************************************************
            * Call::'/booking/lockfares/{lockCode}', (GET)
            * Call::'/booking/lockfares/{lockCode}/includeservices', (GET)
            *
            * Desc:
            * Note: Call Seats right after?
            * Note: Call: Module::'Booking'.
            *
            * @param {Object} faresKey (The 'showFares' result)
            * @return
            */
            call_lockFares: function (faresKey) {

                var me = this,
                    hdrs = '',
                    options = {};


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_lockFares');
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Send Ajax Request ---------------------------------------
                axios.get('/booking/lockfares/' + faresKey + '/includeservices')
                    .then(function(response) {  // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.actn_setBookingLockfaresResults(response.data); // rem res

                                // >>> Got 'Seat' Service?
                                if (response.data.outwardFlight.offersSeatService === true) {
                                    me.actn_setBookingSrvcsSeatExistOnOut(true); // rem
                                }

                                if (response.data.inboundFlight !== null) {
                                    if (response.data.inboundFlight.offersSeatService === true) {
                                        me.actn_setBookingSrvcsSeatExistOnRet(true); // rem
                                    }
                                }


                                if (response.data.outwardFlight.offersSeatService === true || (response.data.inboundFlight !== null && response.data.inboundFlight.offersSeatService === true)) {
                                    me.prepare_call_getSeatReservationLockingCode();
                                } else {
                                    me.$vp_um();

                                    me.$router.push({ path: '/passengers/' + me.modulo  });

                                    setTimeout(function() {
                                        me.$scrollTo('#scrollPointTop', 200, options);
                                    }, 300);
                                }
                                break;
                            default: // 'ERROR'
                                // me.$toc('I am in Header Error');
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_lockFares()



            /******************************************************************* 'ServiceCalls - Services'
            * ServiceCalls: 'Services'
            *******************************************************************/
            /*******************************************************************
            * Call::'/registration/bookingoptions'
            *
            * Desc:
            * Note: New: Axios Call is here managed in VUEX.
            *
            */
            call_registrationBookingoptions: function () {

                var me = this,
                    outwardId = this.getBookingFlightIdSelectedOutward,
                    returnId = this.getBookingFlightIdSelectedReturn,
                    flightIds = [],
                    hdrs = '';


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_registrationBookingoptions');
                // >>> 1. Builds Object ----------------------------------------
                if (outwardId !== null && outwardId !== undefined && outwardId !== '') {
                  flightIds.push(String(outwardId));
                }
                if (returnId !== null && returnId !== undefined && returnId !== '') {
                  flightIds.push(String(returnId));
                }

                const requestParamObject = {
                    "bookingOptionsRQ" : {
                        "idFlights" : flightIds
                    }
                };


                this.actn_call_registrationBookingoptions(requestParamObject);  // Call

            }, // eo function call_registrationBookingoptions()


            /*******************************************************************
            * Call::'/service/bookableservices/{idFlight}/{tktClass}'
            *
            * Desc:
            * Note: Call Seats right after?
            * Note: Call: Module::'Services'.
            * Note: New: Axios Call is here managed in VUEX.
            *
            * @param {string} type ('outward','return')
            */
            call_bookableServices: function (type) {

                var me = this,
                    outwardId = this.getBookingFlightIdSelectedOutward,
                    returnId = this.getBookingFlightIdSelectedReturn,
                    id = '';


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_bookableServices');
                // >>> 1. Builds Object ----------------------------------------
                if (type === 'outward') {
                    id = outwardId;
                }
                if (type === 'return') {
                    id = returnId;
                }


                this.actn_call_bookableServices({ id: id, type: type });        // Call

            }, // eo function call_bookableServices()





            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * flightSelected()
            *
            * Desc: Flight selected! Call ACTION(s)!
            * Note: Param 'flight' has ..  'flight', 'type', 'modulo'.
            * Note: Watches 'modulo'!
            *
            * @param {Object} flight (selected Flight)
            * @return {string}
            */
            flightSelected: function(flight) {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> flightSelected');
                this.actn_setBookingUpdateCart(flight);

            }, // eof flightSelected()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToPushPassengers()
            *
            * Desc: Handle 'Push Passengers' after all pre Calls are done.
            * Note:
            *
            */
            onEmit_ReadyToPushPassengers: function() {

                let me = this,
                    options = {};


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> onEmit_ReadyToPushPassengers');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                me.$router.push({ path: '/passengers/' + me.modulo });
                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToPushPassengers()


            /*******************************************************************
            * onEmit_NeedToRerender()
            *
            * Desc: Resets Flightsearch Result Tabs.
            * Note: Sets it back to first (outward) Tab.
            * Note: Fired in: 'FlighSearchTab':'onChange_FlightsSearchForm'
            *
            */
            onEmit_NeedToRerender: function() {

                let me = this;


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> onEmit_NeedToRerender');
                this.isActive = 'outwardsearchresults'; // reset

            }, // eo function onEmit_ReadyToPushPassengers()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * prepare_call_getSeatReservationLockingCode()
            *
            * Desc: (Prepare) Get Locking Code ('OUT', 'RET')
            * Note:
            *
            * @param
            * @return
            */
            prepare_call_getSeatReservationLockingCode: function() {

                var me = this,
                    owf_id = this.getBookingFlightIdSelectedOutward,
                    rtf_id = this.getBookingFlightIdSelectedReturn,
                    aggrsrvc_exist_out = this.getBookingSrvcsSeatExistOnOut,
                    aggrsrvc_exist_ret = this.getBookingSrvcsSeatExistOnRet;


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> prepare_call_getSeatReservationLockingCode');
                if (owf_id !== '' && aggrsrvc_exist_out === true) { // Got Outward Flight? .. Get LockingCode ..
                    // this.call_getSeatReservationLockingCode('out', owf_id);
                    this.actn_call_getSeatReservationLockingCode({ type: 'out', id:  owf_id });
                }
                if (owf_id !== null && aggrsrvc_exist_out === false) {
                    me.$toasted.global.sdr_app_error({
                        message : me.errornoseatsrvcsonoutward[me.getCurrentLocale]
                    });
                }


                if (rtf_id !== '' && aggrsrvc_exist_ret === true) { // Got Return Flight? .. Get LockingCode ..
                    // this.call_getSeatReservationLockingCode('ret', rtf_id);
                    this.actn_call_getSeatReservationLockingCode({ type: 'ret', id: rtf_id });
                }
                if (rtf_id !== null && aggrsrvc_exist_ret === false) {
                    me.$toasted.global.sdr_app_error({
                        message : me.errornoseatsrvcsonreturn[me.getCurrentLocale]
                    });
                }

            }, // eof prepare_call_getSeatReservationLockingCode()


            /*******************************************************************
            * whichFlightDirection()
            *
            * Desc:
            *
            * @param {string} apt (Airports)
            * @return {string}
            */
            whichFlightDirection: function(apt) {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> whichFlightDirection');
                if (apt === this.getBookingDepArprtCode) {
                    return this.outwardflight[this.getCurrentLocale];
                } else {
                    return this.returnflight[this.getCurrentLocale];
                }

            }, // eof whichFlightDirection()


            /*******************************************************************
            * filterOutwardOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterOutwardOnly: function (flights) {

                let me = this;


                // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterOutwardOnly');
                return flights.filter(function (flight) {
                    return flight.depArprt.i === me.getBookingDepArprtCode;
                });

            }, // eof filterOutwardOnly()


            /*******************************************************************
            * filterReturnOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterReturnOnly: function (flights) {

                let me = this;


                // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterReturnOnly');
                return flights.filter(function (flight) {
                    return flight.depArprt.i !== me.getBookingDepArprtCode;
                });

            } // eof filterReturnOnly()

        }, // eof methods{}
        /* <<< ****************************************************************/

    };

</script>

<style scoped>
    /* >>> -------------------------------------------------------------------*/
    .tab-container .tab-content .tab-pane {
        padding: 0px;
    }
    .tab-container .tab-content {
        background: none;
    }
    .tab-container .tab-content .tab-pane .row {
        margin-bottom: 1px;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }
    .listing-style3 [class^="soap-icon"].circle:hover {
        color: #ec008b;
    }
    .listing-style3 [class^="soap-icon"].circle.yellowchossen {
        color: #ec008b;
    }
    .listing-style3 [class^="soap-icon"].circle.bluechossen {
        color: #4A6E89;
    }
    .listing-style3 [class^="soap-icon"].circle.greychossen {
        color: #D9D9D8;
    }

    .alert.alert-info {
        background: #64A8DB;
    }


    .listing-style3.flight figure span img {
        max-width: 35px;
    }

    .silver-color {
        color: #D9D9D8 !important;
    }

    .tab-container.style1 ul.tabs li.active > a, .tab-container.style1 ul.tabs li:hover > a {
        color: #fff;
        background: #ec008b;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_srvcs > a, .tab-container.style1 ul.tabs.srvcs li:hover > a {
        color: #fff;
        background: #4A6E89;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_srvcs > a:after, .tab-container.style1 ul.tabs.srvcs li:hover > a:after {
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -10px;
        border-top: 5px solid #4A6E89;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        content: "";
    }


    /* >>> SearchResult Hoover -----------------------------------------------*/
    .div_hover { margin-bottom: 2px; }
    .div_hover:hover {
        box-shadow: 0 0 0.5px 0.5px #c0de92
    }


    .icon-check2 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check2:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #ec008b;
    }
    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4A6E89;
    }

    .image-box .discount {
        line-height: 70px;
        text-indent: -10px;
    }



    .skin-color-srvcs {
        color: #4A6E89;
    }




    .listing-style3.flight figure span img {
        max-width: 85px;
    }

    .topDistance {
        margin-top: 25px;
    }




    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
        h3 {
            font-size: 1.5em;
        }
        h4 {
            font-size: 1.2em;
        }

        .topDistance {
            margin-top: 17px;
        }

        button.btn-small, input[type="button"].button.btn-small, a.button.btn-small {
            font-size: 0.70em; /* 'Flug wählen */
        }

        .price {
            font-size: 1.4em;
        }

        .listing-style3.flight .details .details-wrapper > * > * {
            display: table-cell;
            padding: 3px 3px 0 3px;
        }

        .listing-style3 [class^="soap-icon"].circle {
            font-size: 13px;
        }

        .button.btn-mini {
            padding-left: 5px;
            padding-right: 5px;
        }

        .listing-style3.flight figure span img {
            max-width: 35px;
        }

        .listing-style3.flight .details .details-wrapper .time > div {
            padding-left: 5px;
        }


        .image-box .discount {
            font-size: 0.75em;
        }
        /* .image-box .has-discount:before, .image-box .discount {
            left: -4px;
            top: 0px;
            width: 100px;
            height: 105px;
        } */

        button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
            font-size: 1.0em;
        }


        .listing-style3.flight .box, .listing-style3.flight.box {
            padding: 4px;
        }
    }




    /* >>> -------------------------------------------------------------------*/
    .buttonglowing {
        background-color: #004a7f;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        border: none;
        color: #ffffff;
        cursor: pointer;
        /* display: inline-block; */
        /* font-family: Arial;
        font-size: 20px; */
        /* padding: 5px 10px;
        text-align: center;
        text-decoration: none; */
        -webkit-animation: glowing 1500ms infinite;
        -moz-animation: glowing 1500ms infinite;
        -o-animation: glowing 1500ms infinite;
        animation: glowing 1500ms infinite;
    }

    @-webkit-keyframes glowing {
        0% {
            background-color: #e11a33; /* b20000 */
            -webkit-box-shadow: 0 0 3px #e11a33; /* b20000 */
        }
        50% {
            background-color: #7c2525; /* ff0000 */
            -webkit-box-shadow: 0 0 20px #7c2525; /* ff0000 */
        }
        100% {
            background-color: #e11a33;
            -webkit-box-shadow: 0 0 3px #e11a33;
        }
    }

    @-moz-keyframes glowing {
        0% {
            background-color: #e11a33;
            -moz-box-shadow: 0 0 3px #e11a33;
        }
        50% {
            background-color: #7c2525;
            -moz-box-shadow: 0 0 20px #7c2525;
        }
        100% {
            background-color: #e11a33;
            -moz-box-shadow: 0 0 3px #e11a33;
        }
    }

    @-o-keyframes glowing {
        0% {
            background-color: #e11a33;
            box-shadow: 0 0 3px #e11a33;
        }
        50% {
            background-color: #7c2525;
            box-shadow: 0 0 20px #7c2525;
        }
        100% {
            background-color: #e11a33;
            box-shadow: 0 0 3px #e11a33;
        }
    }

    @keyframes glowing {
        0% {
            background-color: #e11a33;
            box-shadow: 0 0 3px #e11a33;
        }
        50% {
            background-color: #7c2525;
            box-shadow: 0 0 0px #7c2525;
        }
        100% {
            background-color: #e11a33;
            box-shadow: 0 0 3px #e11a33;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/flightsearch/FlightSearchResults.vue